/*
 * ds-faq.js — раскрытие вопроса FAQ по якорю.
 *
 * Карточки механик на «Акциях» ведут каждая в свой вопрос (#faq-referral и
 * т. п.): условие на карточке короткое, полное правило — в FAQ. Браузер по
 * якорю только прокручивает страницу, но <details> оставляет закрытым, поэтому
 * вопрос открывает этот скрипт.
 *
 * Без совпадающего якоря скрипт ничего не делает — он безопасен для страниц,
 * где у вопросов нет id.
 */

(function () {
  if (window.dsFaqAnchor) return;
  window.dsFaqAnchor = true;

  function openFromHash() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    var target;
    try {
      target = document.querySelector(hash);
    } catch (error) {
      /* Хэш может быть чем угодно — например, служебным якорём приложения. */
      return;
    }

    if (!target || target.tagName !== 'DETAILS') return;

    /* Единичное раскрытие: тот же контракт, что у самого списка вопросов. */
    var list = target.parentElement;
    if (list) {
      Array.prototype.forEach.call(list.querySelectorAll('details[open]'), function (item) {
        if (item !== target) item.open = false;
      });
    }

    target.open = true;
    target.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  window.addEventListener('hashchange', openFromHash);

  /*
   * Повторный клик по ссылке с тем же якорем hashchange не вызывает, а вопрос
   * покупатель мог уже закрыть руками — поэтому слушаем и сами клики.
   */
  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href*="#"]') : null;
    if (!link) return;
    if (link.hash && link.pathname === window.location.pathname) {
      window.setTimeout(openFromHash, 0);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFromHash);
  } else {
    openFromHash();
  }
})();
